import React from 'react';
import {
	Button,
	Container,
	ContentLayout,
	FlashbarProps,
	Header,
	SpaceBetween,
} from '@amzn/awsui-components-console';
import {
	generateTitleFromDBKey,
	getDateAndTimeFromEpoch,
} from 'src/utils/CommonUtils';
import { TaskDetails } from 'src/@types/selfServeTypes/taskExecutionData.interface';
import TaskActionButtons from '../commonComponents/taskActionButtons';

export interface TaskDetailsPanelProps {
	taskDetails: TaskDetails;
	showTaskDetails: () => void;
	refreshView: () => void;
	hasExecutePermissions: boolean;
	setFlashBarItems?: (items: FlashbarProps.MessageDefinition[]) => void;
}

function TaskDetailsPanel({
	taskDetails,
	showTaskDetails,
	refreshView,
	hasExecutePermissions,
	setFlashBarItems,
}: TaskDetailsPanelProps) {
	const { workflowId, workflowExecutionId } = taskDetails;
	const detailsToShow = [
		'taskName',
		'startTime',
		'taskType',
		'taskOwner',
		'status',
	];

	return (
		<ContentLayout data-testid="task-details-panel">
			<Container
				header={
					<SpaceBetween size="m">
						<Header
							actions={
								<>
									<Button
										data-testid="task-details-panel-close"
										iconName="close"
										variant="icon"
										onClick={showTaskDetails}
									/>
								</>
							}
						>
							Task Details
						</Header>
					</SpaceBetween>
				}
				footer={
					<TaskActionButtons
						refreshView={refreshView}
						taskDetails={taskDetails}
						workflowId={workflowId}
						workflowExecutionId={workflowExecutionId}
						hasExecutePermissions={hasExecutePermissions}
						setFlashBarItems={setFlashBarItems}
					/>
				}
			>
				{Object.keys(taskDetails)
					.filter((val) => detailsToShow.includes(val))
					.map((key) => (
						<React.Fragment key={key}>
							<b>{generateTitleFromDBKey(key)}</b>
							<p>
								{key === 'startTime'
									? Number(taskDetails[key])
										? getDateAndTimeFromEpoch(taskDetails[key])
										: '-'
									: taskDetails[key]}
							</p>
						</React.Fragment>
					))}
			</Container>
		</ContentLayout>
	);
}

export default TaskDetailsPanel;
